import axios from 'axios';
import { API_BASE_URL, API_ORIGIN, handleApiError } from './_apiBase';

// ── QR-punkter: publika sidan (/qr/<token>) ──────────────────────────────────
// Enhetstoken ("kom ihåg den här telefonen") skickas i X-Qr-Device-headern.

export interface QrPointPublic {
    name: string;
    zone_name: string | null;
    template_name: string | null;
    can_inspect: boolean;
    viewer: { id: number; name: string } | null;
}

const pub = (token: string, path = '') => `${API_ORIGIN}/api/qr/${token}${path}`;
const deviceHeaders = (deviceToken: string | null) =>
    deviceToken ? { 'X-Qr-Device': deviceToken } : undefined;

export const fetchQrPoint = async (token: string, deviceToken: string | null): Promise<QrPointPublic> =>
    (await axios.get<QrPointPublic>(pub(token), { headers: deviceHeaders(deviceToken) })).data;

export const requestQrCode = async (token: string, phone: string): Promise<{ ok: boolean; message: string }> =>
    (await axios.post(pub(token, '/request-code'), { phone })).data;

export const verifyQrCode = async (token: string, phone: string, code: string):
    Promise<{ ok: boolean; device_token: string; viewer: { id: number; name: string } }> =>
    (await axios.post(pub(token, '/verify-code'), { phone, code })).data;

export const startQrInspection = async (token: string, deviceToken: string):
    Promise<{ inspection_token: string; viewer: { id: number; name: string } }> =>
    (await axios.post(pub(token, '/start'), {}, { headers: deviceHeaders(deviceToken) })).data;

// ── QR-punkter: admin ────────────────────────────────────────────────────────

export interface QrPoint {
    id: number;
    token: string;
    name: string;
    zone_id: number | null;
    zone_name: string | null;
    template_id: number | null;
    template_name: string | null;
    active: boolean;
    created_at: string;
}

export const fetchQrPoints = async (): Promise<QrPoint[]> => {
    try { return (await axios.get(`${API_BASE_URL}/qr-points`)).data; }
    catch (error) { return handleApiError(error, 'Hämta QR-punkter'); }
};

export const createQrPoint = async (body: Partial<QrPoint>): Promise<QrPoint> => {
    try { return (await axios.post(`${API_BASE_URL}/qr-points`, body)).data; }
    catch (error) { return handleApiError(error, 'Skapa QR-punkt'); }
};

export const updateQrPoint = async (id: number, body: Partial<QrPoint>): Promise<QrPoint> => {
    try { return (await axios.put(`${API_BASE_URL}/qr-points/${id}`, body)).data; }
    catch (error) { return handleApiError(error, 'Spara QR-punkt'); }
};

export const newQrPointToken = async (id: number): Promise<QrPoint> => {
    try { return (await axios.post(`${API_BASE_URL}/qr-points/${id}/new-token`)).data; }
    catch (error) { return handleApiError(error, 'Byta QR-kod'); }
};

export const deleteQrPoint = async (id: number): Promise<void> => {
    try { await axios.delete(`${API_BASE_URL}/qr-points/${id}`); }
    catch (error) { return handleApiError(error, 'Ta bort QR-punkt'); }
};
